import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    footer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
  };
});

const Footer = ({ footerRef, children, ...props }) => {
  const classes = useStyles();

  return (
    <footer ref={footerRef} className={classes.footer} {...props}>
      {children}
    </footer>
  );
};

Footer.propTypes = {
  children: PropTypes.node,
};

Footer.defaultProps = {};

export default Footer;
